<template>
    <div id="vx-col w-full mb-base">
      <vs-popup
        :title="interIsEdit? 'Misé a jour: ' + thisThema.name : 'Internationale'"
        :active.sync="interIsPopupActive">
        <NetlinkThemaPopup v-if="currentTab == 0" :isPopupActive="interIsPopupActive" :thematique="thisThema" :isEdit="interIsEdit" @close-thema-popup="closeintlpopup()"/>
        <NetlinkThemaIntlPopup v-else :isPopupActive="interIsPopupActive" :thematique="thisThema" :isEdit="interIsEdit" @close-intl-popup="closeintlpopup()" />
        </vs-popup>
        <vs-popup
        :title="'Supprimer: ' + thisThema.name"
        :active.sync="isValidationPopupActive">
        <div style="display:flex; justify-content: space-around;">
            <vs-button @click="isPopupActive=false"> Non</vs-button>
            <vs-button @click="deleteThema()" color="danger"> Oui</vs-button>
        </div>
        </vs-popup>
      <!-- PRODUCT TABLE -->
      <vs-button class="mb-5" @click="addFunc()">Ajouter</vs-button>
      <vx-card style="max-height:76vh; overflow: auto;">
		<vs-tabs v-model="currentTab">
			<vs-tab  label="Thématique">
        <NetlinkThemaTable @edit-popup="editPopup"/>
			</vs-tab>
			<vs-tab label="Internationale">
        <NetlinkInternationalTable @edit-popup="editPopup"/>
			</vs-tab>
		</vs-tabs>
    </vx-card>


    </div>
  </template>

<script>
import NetlinkThemaTable from "@/components/tables/NetlinkThemaTable";
import NetlinkInternationalTable from "@/components/tables/NetlinkInternationalTable";
import NetlinkThemaIntlPopup from "@/components/popups/NetlinkIntlPopup";
import NetlinkThemaPopup from "@/components/popups/NetlinkThemaPopup";


export default {
	components: {NetlinkThemaTable, NetlinkInternationalTable, NetlinkThemaIntlPopup, NetlinkThemaPopup},
	name: "NetlinkThemaDashboard",
	data() {
		return {
			interIsEdit: true,
			interIsPopupActive: false,
			isValidationPopupActive: false,
			apiUrl: this.$store.state.backendApiUrl,
      currentTab: 0,
			thisThema: {}
		};
	},
	methods: {
		addFunc(){
      this.addnewIntl();
		},
		addnewIntl(){
			this.interIsEdit = false;
			this.interIsPopupActive = true;
		},
		closeintlpopup(){
			this.interIsPopupActive = false;
		},
		editPopup(data){
      this.interIsEdit = true;
      this.thisThema = data;
			this.interIsPopupActive = true;
		},
		toogleInterPopup(data){
			//console.log("NETLIK THEMA", data);
			this.interIsEdit = data.idEdit;
			this.interIsPopupActive = data.isPopupActive;
		}
	}

};
</script>

  <style scoped>
  .fw-bold {
    font-weight: bold;
    color: black;
  }

  .center {
    justify-content: center;
  }
  </style>
